import { useQuery } from "@tanstack/react-query";
import addressApi from "api/landlord/address";
import { Unit } from "types/landlord/address";
import { AmenitiesSection } from "views/properties-id-units-id/components/AmenitiesSection";

export const FirstUnitAmenitiesSection = ({
  propertyId,
  unitId
}: {
  propertyId: number;
  unitId: number;
}) => {
  const { data: unit } = useQuery<Unit>({
    queryKey: ["unit", String(propertyId), String(unitId)],
    queryFn: () =>
      addressApi.getUnitByPropertyAndUnitId(String(propertyId), String(unitId))
  });

  return unit ? <AmenitiesSection unit={unit} /> : null;
};
